import React, { useState, useEffect } from 'react';
import { UserRectangle, Video, Users } from '@phosphor-icons/react';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';

import { PageWrapper, ContentHeader } from '../../components/layout/content';

import { useProjectStore } from '../../stores/project';

import { PageError } from '../../types';

import MsForm from './msForm';
import MsRequestForm from './msRequestForm';

const ManagedServices = () => {
  const { eventId = '' } = useParams();

  const { currentProject, projectError, setEventId } = useProjectStore();

  const [isShowForm, setIsShowForm] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [pageError, setPageError] = useState<PageError>(null);

  // set event id on mount
  useEffect(() => {
    if (eventId) setEventId(eventId);
    else setIsLoading(false);
  }, [eventId, setEventId]);

  useEffect(() => {
    if (projectError) {
      setPageError(projectError);
      setIsLoading(false);
    } else if (currentProject) {
      setIsShowForm(true);
      setIsLoading(false);
    }
  }, [currentProject, projectError]);

  const reqsBlocks = [
    {
      icon: <UserRectangle />,
      heading: 'Clips',
      subheading:
        'Add a link to your Google Drive, Dropbox folder or similar, where you’ve digitally saved your clips',
    },
    {
      icon: <Video />,
      heading: 'Highlight Reel',
      subheading:
        'Upload your final template/highlight reel file, with wildcard/shot placeholders',
    },
    {
      icon: <Users />,
      heading: 'People',
      subheading:
        'Guest registers using a clear photo or selfie, through a shareable QR Code or URL provided by CrowdClip&reg;',
    },
  ];

  const renderReqsBlocks = () => {
    return (
      <div className="flex flex-col sm:flex-row gap-4 sm:gap-10">
        {reqsBlocks.map((block) => (
          <div
            className="w-full sm:w-1/3 flex flex-row sm:flex-col rounded-md shadow-grey-2"
            key={block.heading}
          >
            <div className="flex items-center justify-center p-10 bg-primary-50 text-[4rem] text-primary-900 rounded-tl-md rounded-tr-md">
              {block.icon}
            </div>

            <div className="min-h-32 flex flex-col p-4 gap-2 text-center">
              <div className="font-bold">{block.heading}</div>
              <div className="text-sm opacity-50">
                {parse(block.subheading)}
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <PageWrapper
      type="generic"
      title="Upload Buddy"
      isLoading={isLoading}
      pageError={pageError}
      className="gap-8"
      noTips
    >
      <ContentHeader
        title="Upload Buddy"
        subtitle="Simply <i>Upload Review Go</i><br /><br />We all know as videographers the uploading of files is the painful bit and takes the longest. We are built by videographers and value your precious time as much as you do! Using this feature, you can simply add all the assets as links in one go and we will notify you when everything is uploaded and ready for your review."
      />

      <div className="flex flex-col gap-4">
        <h3>What you need</h3>

        {renderReqsBlocks()}
      </div>

      {isShowForm && currentProject ? (
        <MsForm event={currentProject} />
      ) : (
        <MsRequestForm />
      )}
    </PageWrapper>
  );
};

export default ManagedServices;
